import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from '../../../components/Seo';

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import {
  HeroHeader,
  ProblemQuestions,
  CourseInvitation,
  VideoPresentation,
  CourseSummary,
  CourseTopics,
  Registration,
} from '../../../components/LandingTemplates/angliyskaya-grammatika-dlya-detey';

import { GetCourseWidget } from '../../../components/GetCourseWidget';
import { FooterFull } from '../../../components/FooterFull';

import * as registration from '../../../components/LandingTemplates/angliyskaya-grammatika-dlya-detey/styles/registration.module.scss';

const TITLE = 'Английская грамматика для детей 5 классов — онлайн-курс Advance';
const DESCRIPTION =
  'Подходит для детей 5 классов и старше. Бесплатный курс, построенный на игровом сценарии, поможет изучить основные грамматические правила английского языка.';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <HeroHeader
        accessLimited={true}
        widget={<GetCourseWidget hash={'ef06aeb562767609b7fbe94be247deeca3c36414'} id={'468206'} />}
      />
      <ProblemQuestions />
      <CourseInvitation />
      <VideoPresentation />
      <CourseSummary />
      <CourseTopics />
      <Registration
        accessLimited={true}
        widget={<GetCourseWidget hash={'ef06aeb562767609b7fbe94be247deeca3c36414'} id={'468206'} />}
      />
    </main>

    <FooterFull />
  </DefaultLayout>
);

export default Page;
